import React from 'react';

import classes from './TravellerButton.scss';

const travellerButton = (props) =>  {
    return (
            <button 
                className={`${[classes.TravellerButton, props.isactive === 'true' ? classes.TravellerButtonActive : null].join(' ')} u-textAlignCenter u-fontWeightRegular u-fontSize11 u-textColorDark u-textUppercase u-cursorPointer u-flex justify-content-center align-items-center`}
                {...props}
                >{props.children}{ props.isactive === 'true' ?  <div className={classes.TravellerArrow}></div> : null }</button>
    );
}

export default travellerButton;


// WEBPACK FOOTER //
// ./src/components/Travellers/TravellerButton/TravellerButton.js